import { randomId } from '@mantine/hooks'

import type { ManualAccountFormSchema } from '@/components/ManualAccountForm/ManualAccountForm.types'

import type {
  estimationMethod,
  ManualAccountData,
} from '@/__generated__/requests'
import { type } from '@/__generated__/requests'

export function manualAccountFormDefaultValues(
  data?: ManualAccountData,
): ManualAccountFormSchema {
  return {
    balance: data?.balance ?? 0,
    balanceDate: data?.balanceDate ?? undefined,
    estimationMethod: (data?.estimationMethod as estimationMethod) ?? undefined,
    includedInNetWorth: data?.includedInNetWorth ?? true,
    initialValue: data?.initialValue ?? undefined,
    initialValueDate: data?.initialValueDate ?? undefined,
    institution: data?.institution ?? '',
    name: data?.name ?? '',
    notes: data?.notes ?? '',
    otherEstimationMethod: data?.otherEstimationMethod ?? '',
    otherType: data?.otherType ?? '',
    type: (data?.type as type) ?? type.OTHER_ASSET,
    valueChanged: data?.valueChanged ?? false,
    valueChanges: data?.valueChanges
      ? data.valueChanges.map(valueChange => ({
          date: valueChange.date,
          id: randomId(),
          value: valueChange.value,
        }))
      : [],
  }
}
